import { dexOfCoin } from '@/lib/hyperliquid/coins';

import { usePerpsMarkets } from '@/hooks/perps/usePerpsMarketFeed';

import { fontStyles } from '@/styles/typography';

import { classNames } from '@/utils/classnames';

export const tagStyles = fontStyles({
  variant: 'LABEL_XS',
  class: 'rounded-xs bg-token-alphalight-100 px-1 py-0.5 text-token-gray-700',
});

type Props = {
  coin: string;
  className?: string;
};

/**
 * Shows the HIP-3 dex symbol of a market, with the deployer's full name on hover. Coins
 * render without their `{dex}:` prefix, so this is what tells `hyna:BTC` apart from `BTC`.
 * Renders nothing for validator-operated markets.
 */
export const DeployerTag = ({ coin, className }: Props) => {
  const deployer = usePerpsMarkets()[coin]?.deployer;
  return deployer ? (
    <span className={classNames(tagStyles, 'shrink-0', className)} title={deployer}>
      {dexOfCoin(coin)}
    </span>
  ) : null;
};
